import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="flex h-screen bg-gray-100" data-id="element-416">
      <Sidebar data-id="element-417" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-418">
        <Header data-id="element-419" />
        <main className="flex-1 overflow-y-auto p-4" data-id="element-420">{children}</main>
      </div>
    </div>;
};
export default Layout;